import request from "@/utils/request";
import qs from "qs-lite";

import {
  IPatchTeamMemberRequest,
  IPostTeamMemberRequest,
  IRemoveTeamMemberRequest,
} from "@/interfaces/requests/team";
import {
  ITeamMembersGetResponse,
  ITeamRolesGetResponse,
  ITeamRoleWriteResponse,
} from "@/interfaces/responses/team";

const FORM_URLENCODED = {
  "Content-Type": "application/x-www-form-urlencoded",
};

/**
 * Get members of the group
 * Postman: `GET_group_role`
 */
export async function getTeamMembers(
  groupId: number
): Promise<ITeamMembersGetResponse> {
  const response = await request({
    url: `/group/${groupId}/role`,
    method: "get",
  });

  return response.data;
}

/**
 * Invite a member to the group (email flow)
 * Postman: `POST_group_role`
 */
export async function postTeamMember(
  payload: IPostTeamMemberRequest
): Promise<ITeamRoleWriteResponse> {
  const { groupId, ...data } = payload;

  const response = await request({
    url: `/group/${groupId}/role`,
    method: "post",
    headers: FORM_URLENCODED,
    data: qs.stringify(data),
  });

  return response.data;
}

/**
 * Update a member's role, email and social security number
 * Postman: `PATCH_group_role`
 */
export async function patchTeamMember(
  payload: IPatchTeamMemberRequest
): Promise<ITeamRoleWriteResponse> {
  const { groupId, roleId, ...data } = payload;

  const response = await request({
    url: `/group/${groupId}/role/${roleId}`,
    method: "patch",
    headers: FORM_URLENCODED,
    data: qs.stringify(data),
  });

  return response.data;
}

/**
 * Remove a member from the group (soft cancel — there is no DELETE verb)
 * Postman: `PATCH_group_role_cancel`
 */
export async function removeTeamMember(
  payload: IRemoveTeamMemberRequest
): Promise<ITeamRoleWriteResponse> {
  const { groupId, roleId } = payload;

  const response = await request({
    url: `/group/${groupId}/role/${roleId}/cancel`,
    method: "patch",
  });

  return response.data;
}

/**
 * Get the role catalogue (role id to label map)
 * Postman: `GET_group_roles`
 */
export async function fetchGroupRoles(): Promise<ITeamRolesGetResponse> {
  const response = await request({
    url: `/group/roles`,
    method: "get",
  });

  return response.data;
}
